module.exports = __webpack_public_path__ + "static/media/XS_Block.0ddb8cfb.jpg";